import {ErrorStateScheduleEnum} from '../../error-state-schedule.enum';

export enum CompanyAddressFormErrorStatesEnum {
    AddressRegistrationFailed = ErrorStateScheduleEnum.CompanyAddressFormFormStatesStartIndex,
    UpdateAddressFailed
}
